// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"738":"0fe8e0ba","949":"47ccb055"}[chunkId] + ".chunk.css";
};